import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

import imgSeniors from '../images/Seniors.jpeg';
import imgSportifs from '../images/trail-running.webp';
import imgActifs from '../images/Actifs.jpeg';
import imgEnfants from '../images/Enfants.jpeg';

export const ConsultationQui = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="text-center mb-10">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">
                        Qui peut nous consulter ?
                    </h1>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4' style={{ borderColor: Helper.footerBackGroundColor }}></div>
                    </div>
                    <p className="text-gray-600 text-base sm:text-lg lg:text-xl mt-6 max-w-3xl mx-auto leading-relaxed">
                        La chiropraxie est indiquée pour tous, sans distinction d'âge ou de condition physique !
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

                    {/* Actifs */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                        <div className="h-48 overflow-hidden">
                            <img alt="Personne active au travail" className="w-full h-full object-cover" src={imgActifs} loading="lazy" />
                        </div>
                        <div className="p-6">
                            <h2 className="font-bold text-xl sm:text-2xl mb-4" style={{ color: Helper.footerBackGroundColor }}>Actifs</h2>
                            <div className="space-y-3 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>Les conditions de travail peuvent influencer directement votre posture et provoquer des douleurs quotidiennes : travail sédentaire, port de charges lourdes, mouvements répétitifs, postures inadaptées, stress élevé...</p>
                                <p className="font-semibold" style={{ color: Helper.footerBackGroundColor }}>Notre but ? Réduire la douleur et vous accompagner dans votre évolution.</p>
                                <p className="text-sm italic text-gray-500">Plus vous consulterez rapidement après l'apparition des douleurs, plus vite vous pourrez vous en défaire.</p>
                            </div>
                        </div>
                    </div>

                    {/* Sportifs */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                        <div className="h-48 overflow-hidden">
                            <img alt="Sportif en course à pied" className="w-full h-full object-cover" src={imgSportifs} loading="lazy" />
                        </div>
                        <div className="p-6">
                            <h2 className="font-bold text-xl sm:text-2xl mb-4" style={{ color: Helper.footerBackGroundColor }}>Sportifs</h2>
                            <div className="space-y-3 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>La pratique sportive engendre des sollicitations musculaires et articulaires importantes. Les gestes répétitifs peuvent amener votre corps à ses limites.</p>
                                <p>Les bénéfices pour le sportif : soulagement des douleurs, prévention des blessures, amélioration de la récupération et optimisation des performances.</p>
                                <p className="font-semibold" style={{ color: Helper.footerBackGroundColor }}>Notre but ? Que votre corps soit à 100% de ses fonctions !</p>
                            </div>
                        </div>
                    </div>

                    {/* Seniors */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                        <div className="h-48 overflow-hidden">
                            <img alt="Couple de seniors actifs" className="w-full h-full object-cover" src={imgSeniors} loading="lazy" />
                        </div>
                        <div className="p-6">
                            <h2 className="font-bold text-xl sm:text-2xl mb-4" style={{ color: Helper.footerBackGroundColor }}>Séniors</h2>
                            <div className="space-y-3 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>Avec l'âge, les os s'usent, les muscles perdent en tonicité et les articulations en souplesse. Ces phénomènes affectent progressivement la mobilité.</p>
                                <p>Notre cabinet dispose de tables spécifiques adaptées aux grandes pathologies comme le canal lombaire étroit.</p>
                                <p className="font-semibold" style={{ color: Helper.footerBackGroundColor }}>Notre but ? Réduire les raideurs et restaurer votre mobilité articulaire.</p>
                            </div>
                        </div>
                    </div>

                    {/* Enfants */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                        <div className="h-48 overflow-hidden">
                            <img alt="Enfants jouant" className="w-full h-full object-cover" src={imgEnfants} loading="lazy" />
                        </div>
                        <div className="p-6">
                            <h2 className="font-bold text-xl sm:text-2xl mb-4" style={{ color: Helper.footerBackGroundColor }}>Enfants et adolescents</h2>
                            <div className="space-y-3 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>Le corps de l'enfant est constamment sollicité : cartable lourd, heures assis, activités sportives... La période de croissance est charnière.</p>
                                <p>Les mauvaises postures devant les écrans favorisent l'apparition de dysfonctions vertébrales.</p>
                                <p className="font-semibold" style={{ color: Helper.footerBackGroundColor }}>Notre but ? Accompagner la croissance dans ces grandes périodes de transition.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center mt-10">
                    <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                        Prendre rendez-vous
                    </button>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
